module.exports = __webpack_public_path__ + "static/media/34DSS6.39d9ff75.jpg";